import React, { Component } from "react";
import { connect } from "react-redux";
import { last, size } from "lodash";

import {
  selectOption,
  setOption,
  selectSubOption,
  setSubOption,
  setOptionOtherText,
  setSubOptionOtherText,
  selectLanguage,
  hideModal,
  addOptionFile,
  removeOptionFile,
  addSubOptionFile,
  removeSubOptionFile,
  setConsent,
  setOptionError,
  clearOptionError,
  selectAllOptions,
  unSelectAllOptions,
  selectItemForQuestion,
  validateCurrentSection,
} from "state/modules/response";
import {
  getSurveyLogo,
  getSurveyBackground,
} from "state/modules/survey/selectors";
import { setDivision } from "state/modules/division";
import {
  navForward,
  navBackward,
  showCorrectAnswer,
} from "state/modules/navigation";
import { submitFeedback } from "state/modules/feedback";

import Layout from "./view";

class Question extends Component {
  render = () => <Layout {...this.props} />;
}

const mapDispatchToProps = {
  navForward,
  navBackward,
  selectOption,
  setOption,
  selectSubOption,
  setSubOption,
  setOptionOtherText,
  setSubOptionOtherText,
  selectLanguage,
  setDivision,
  hideModal,
  addOptionFile,
  removeOptionFile,
  addSubOptionFile,
  removeSubOptionFile,
  setConsent,
  setOptionError,
  clearOptionError,
  submitFeedback,
  selectAllOptions,
  unSelectAllOptions,
  selectItemForQuestion,
  showCorrectAnswer,
  validateCurrentSection,
};

const mapStateToProps = state => {
  const {
    sectionStack,
    shouldShowAnswer,
    is_submit_clicked,
  } = state.navigation;
  const section = last(sectionStack);
  const sequence = size(sectionStack);

  const isEnglish = state.response.lang === "text";

  const logo = getSurveyLogo(state);
  const background = getSurveyBackground(null, state);

  return {
    section,
    sequence,
    logo,
    background,
    isQuiz: state.survey.isQuiz,
    shouldShowAnswer: shouldShowAnswer,
    is_submit_clicked: is_submit_clicked,
    response: state.response,
    optionErrors: state.response.errors,
    organization: state.organization.name,
    modal: state.response.modal,
    isValid: state.response.canMoveForward,
    lang: state.response.lang,
    division: state.division,
    divisions: state.organization.divisions,
    divisionInfo: state.survey.divisionInfo,
    status: state.survey.status,
    items: state.survey.items,
    autoStart: state.survey.autoStart,
    isEnglish,
    feedbackStatus: state.feedback.status,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Question);
